class Toc {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  initialize() {
    this.bindUI();
    this.bindEvents();
  }

  unmount() {
    this.ui = {};
    this.headers = null;
  }

  bindUI() {
    this.ui = {};
    this.ui.$items = [...this.element.querySelectorAll('[data-ref="toc-item"]')];
    this.ui.$domItems = [...document.querySelectorAll('.section:not(.pageHero) h2')];
    this.headers = this.ui.$domItems.map((item) => {
      return item.textContent;
    });
  }

  bindEvents() {
    this.ui.$items.forEach((element) => {
      if (!this.headers.includes(element.textContent)) {
        element.remove();
      }
    });
  }
}

export default Toc;
